import React from 'react';
import Icon from '../ui/Icon';
import './InterventionCard.css';

// One flagged student — "who needs attention right now" (docs/UI_UX_
// ARCHITECTURE.md Admin Phase 5 §15). `student` shape is deliberately
// generic across the two existing intervention sources (college-level
// analyticsController.getCollegeDashboard.intervention.students and
// batch-level batchAnalyticsController.getBatchIntervention) — the caller
// normalizes into { name, readiness_label, primary_gap, trend, evidence,
// reasons } so this component never reinterprets either source's own
// reasoning, just displays it.
const TREND_LABEL = { improving: 'Improving', declining: 'Declining', stable: 'Stable', insufficient_data: null };

const InterventionCard = ({ student, onView }) => (
  <div className="ivc-card">
    <div className="ivc-top">
      <span className="ivc-name">{student.name}</span>
      {student.readiness_label && <span className="ivc-badge">{student.readiness_label}</span>}
    </div>
    {student.primary_gap && (
      <div className="ivc-row"><span className="ivc-row-label">Primary gap:</span> {student.primary_gap}</div>
    )}
    {student.trend && TREND_LABEL[student.trend] && (
      <div className="ivc-row"><span className="ivc-row-label">Trend:</span> {TREND_LABEL[student.trend]}</div>
    )}
    {student.evidence && (
      <div className="ivc-row"><span className="ivc-row-label">Evidence:</span> {student.evidence}</div>
    )}
    <button type="button" className="ivc-btn" onClick={onView}>View Student</button>
  </div>
);

export default InterventionCard;
